import { Link } from "@tanstack/react-router";

import { cn } from "@/lib/classNames";

import { ADMIN_TOOLS } from "./adminTools";

function isToolActive(currentPath: string, tool: (typeof ADMIN_TOOLS)[number]): boolean {
  const match = tool.match ?? "prefix";
  if (match === "exact") {
    return currentPath === tool.href;
  }
  return currentPath === tool.href || currentPath.startsWith(`${tool.href}/`);
}

export function AdminTabNav({ currentPath }: { currentPath: string }) {
  return (
    <nav aria-label="Admin tools" className="flex flex-wrap gap-2">
      {ADMIN_TOOLS.map((tool) => {
        const active = isToolActive(currentPath, tool);

        return (
          <Link
            key={tool.href}
            to={tool.href}
            aria-current={active ? "page" : undefined}
            className={cn(
              "border-2 px-3 py-2 text-[11px] font-semibold uppercase tracking-[0.12em] transition-colors",
              active
                ? "border-neutral-950 bg-neutral-950 text-[#fff7ec] shadow-[4px_4px_0_rgba(19,19,19,0.2)]"
                : "border-transparent text-neutral-800 hover:border-neutral-950/25 hover:bg-white/60",
            )}
          >
            {tool.label}
          </Link>
        );
      })}
    </nav>
  );
}
